<template>
    <div id="profile" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area" v-show="showLeaveCalendarList == 0">
            <div class="page-name">
                <div class="page-title">Leave/Holiday Calendar</div>
                <button id="addLeaveHolidayBtn" v-on:click.prevent="addLeaveHoliday" class="btn btn-primary pull-right" v-if="canAddLeave" > <i class="fp-add"> </i> Add</button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content maintenance-schedule">
                    <section class="internal-container border-top-table-fl">
                        <div class="form-row">
                            <div class="col-3 form-group">
                                <v-select class="close-remove" v-model="filter_location_id" name="filter_location_id" placeholder="Select Location." label="text"
                                    :options="locationArr" @input="onLocationChange">
                                </v-select>
                            </div>
                            <div class="col form-group"></div>
                            <div class="col form-group"></div>
                            <div class="col-1 form-group">
                                <button type="submit" v-on:click.prevent="resetFilter()" class="btn btn-tertiary pull-right">
                                    <i class="fp-refresh"></i> Reset
                                </button>
                            </div>
                        </div>
                        <div class="mb-4 btn-groups text-right">
                            <template v-for="(key,keyInd) in keysArr">
                                <template v-if='key.is_view == 1'>
                                    <button
                                        :key='key.value+"_"+key.is_view'
                                        @click="changeVisible(key.value)"
                                        :id="'key_'+key.value+keyInd" class="mt-2 mr-3 btn"
                                        :title='key.text + " is visible"'
                                        :style="'color:#FFFFFF;background:'+ key.color_code + ';border:'+ key.color_code + '; opacity:1;'"
                                        >{{key.text}}</button>
                                </template>
                                <template v-else>
                                    <button
                                        :key='key.value+"_"+key.is_view'
                                        @click="changeVisible(key.value)"
                                        :id="'key_'+key.value+keyInd" class="mt-2 mr-3 btn"
                                        :title='key.text + " is not visible"'
                                        :style="'color:#FFFFFF;background:'+ key.color_code+';border:'+ key.color_code+'; opacity:0.5;'"
                                        >{{key.text}}</button>
                                </template>
                            </template>
                        </div>    
                        <div class="SMcalendarContainer">
                            <div class="nevCalendar" style="float:left;">
                                <button id="" class="btn btn-primary" @click="previousMonth" ><i style="font-size:24px;padding:0" class="fp-left-arrow" aria-hidden="true"></i></button>
                                <button id="" class="btn btn-primary" @click="nextMonth"><i style="font-size:24px;padding:0" class="fp-right-arrow" aria-hidden="true"></i></button>
                            </div>
                            <full-calendar id="LHcalendar" :config="config" :events="display_events" ref="LHcalendar"/>
                        </div>    
                    </section>
                </div>        
            </div>
            <app-footer></app-footer>    
        </div>
        <div id="page-content-wrapper" class="admin-content-area" v-show="showLeaveCalendarList == 1">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="leaveHolidayHeader" v-if="leave_holiday_id > 0">Update Leave/Holiday</span>
                    <span class="page-title" id="leaveHolidayHeader" v-else>Add Leave/Holiday</span>
                    <div class="btn-groups text-right">
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backToCalendar">
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content leave-holiday-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="leaveHolidayForm">
                                <div class='form-row row-cols-md-4 row-cols-1'>
                                    <div class="col form-group">
                                        <label class="control-label require" for="type_leave">Type:</label>
                                        <v-select id="type_select" v-model="type_select" name="type_select" placeholder="Select Type." label="text"
                                            class="close-remove" :options="calendarTypesArr" @input="onTypeSelect($event)" :disabled="disable_type_select">
                                        </v-select>
                                        <div class="field-error">{{ type_select_error_msg }}</div>
                                    </div>
                                    <template v-if="type_select != null && type_select.value == 'holiday'">
                                        <div class="col form-group">
                                            <label class="control-label require" for="state">Location:</label>
                                            <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" :options="locationArr" class="close-remove">
                                            </v-select>
                                            <div class="field-error">{{location_error_msg}}</div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col form-group">
                                            <label class="control-label require" for="user_id">User:</label>
                                            <v-select v-model="user_id" name="user_id" placeholder="Select User." label="text" :options="techUsersArr" class="close-remove" :disabled="disable_type_select">
                                            </v-select>
                                            <div class="field-error">{{user_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="type_leave">Leave Type:</label>
                                            <v-select id="leave_type" v-model="leave_type" name="leave_type" placeholder="Select Leave Type." label="text"
                                                class="close-remove" :options="leaveTypesArr" @input="onLeaveTypeChange($event)">
                                            </v-select>
                                            <div class="field-error">{{ leave_type_error_msg }}</div>
                                        </div>
                                        <template v-if="is_weekly == 1">
                                            <div class="col form-group">
                                                <label class="control-label require" for="days">Days:</label>
                                                <v-select v-model="weekDays" name="weekdays" placeholder="Select Days." label="text"
                                                    :options="weekArr" class="close-remove"></v-select>
                                                <div class="field-error">{{ days_error_msg }}</div>
                                            </div>
                                        </template>    
                                    </template>        
                                </div>
                                <div class='form-row'>
                                    <div class="col-md-6 form-group">
                                        <label :class="subject_class" for="subject">Subject:</label>
                                        <input type="text" class="form-control" v-model="subject" id="subject" placeholder="Enter Subject." name="subject">
                                        <div class="field-error">{{ subject_error_msg }}</div>
                                    </div>
                                    <template v-if="is_weekly == 0">
                                    <div class="col form-group">
                                        <label class="control-label require" for="from_date">Start Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="from_date" name="from_date" v-model="from_date" :config="optionsDate"></date-picker>
                                            <label for="from_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ from_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="to_date">End Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="to_date" name="to_date" v-model="to_date" :config="optionsDate"></date-picker>
                                            <label for="to_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ to_date_error_msg }}</div>
                                    </div>
                                    </template>
                                </div>
                                <template v-if="type_select != null && type_select.value == 'leave'">    
                                    <div class="form-row row-cols-md-2 row-cols-1">
                                        <div class="col form-group">
                                            <label class="control-label" for="description">Description:</label>
                                            <textarea class='form-control rounded-0' v-model="description" ref="textarea" id="description" name="description" placeholder="Enter Description." rows="3"></textarea>
                                            <div class="field-error"></div>
                                        </div>
                                    </div>
                                </template>
                                <div class="form-row row-cols-md-2 row-cols-1" v-if="leave_holiday_id != 0 && is_weekly == 1">
                                    <div class="col form-group">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom">Apply to all Leaves
                                            <input type="checkbox" v-model="apply_all" id="apply_all" name="apply_all" v-on:click="applyAll($event)">
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>        
                                <div class="field-error check-error" style="margin-left:0px;">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>            
                                <div class="btn-groups">
                                    <template v-if="leave_holiday_id > 0">
                                        <button type="submit" id="updateLeaveCalendarBtn" class="btn btn-primary" v-on:click.prevent="createLeaveHoliday('Update')" >
                                            <i class="fp-reload"> </i>  Update
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button type="submit" id="createLeaveCalendarBtn" class="btn btn-primary" v-on:click.prevent="createLeaveHoliday('Save')" >
                                            <i class="fp-save"> </i>  Save
                                        </button>
                                        <button type="submit" id="createAndContinueLeaveCalendarBtn" class="btn btn-primary" v-on:click.prevent="createLeaveHoliday('Save and Continue')" >
                                            <i class="fp-save"> </i>  Save and Continue
                                        </button>
                                    </template>        
                                    <button type="submit" id="cancelLeaveCalendarBtn" class="btn btn-tertiary" v-on:click.prevent="backToCalendar" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                    <button v-if="canDeleteLeave && leave_holiday_id > 0" type="submit" class="btn btn-danger" v-on:click.prevent="deleteLeaveHoliday">Delete</button>    
                                </div>    
                            </form>    
                        </section>    
                    </div>    
                </div>        
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                    </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>        
    </div>    
</template>
<script>
import Vue from "vue";
import moment from 'moment'
import EventBus from "./event-bus";
import FullCalendar from "vue-full-calendar";
import {contractMixins} from '../mixins/contractMixins';
import {commonMixins} from '../mixins/commonMixins';
import "fullcalendar/dist/fullcalendar.min.css";

Vue.use(FullCalendar);
var contex;
export default {
    name: "LeaveHolidayCalendar",
    
    mixins:[commonMixins,contractMixins],
    data() {
        return {            
            permissions: [],
            cantAccessPage:'',
            canAddLeave:false,
            canDeleteLeave:false,
            leave_holiday_id:0,
            showLeaveCalendarList:0,
            loading:false,
            type_select:{text:"Leave",value:"leave"},
            type_select_error_msg:"",
            leave_type:"",
            leave_type_error_msg:"",
            subject:"",
            subject_error_msg:"",
            from_date:"",
            from_date_error_msg:"",
            to_date:"",
            to_date_error_msg:"",
            description:"",
            techUsersArr:[],
            user_id:"",
            user_error_msg:"",
            locationArr:[],
            location_id:"",
            location_error_msg:"",
            common_error_msg:"",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent:false,
            },
            subject_class:"control-label",
            start_date:"",
            end_date:"",
            events:[],
            keysArr:[],
            display_events:[],
            renderedView:'',
            selectedEvent: {},
            filter_location_id:"",
            is_weekly:0,
            weekDays:null,
            days_error_msg:"",
            disable_type_select:false,
            apply_all:false,
            config: {
                defaultView: 'month',
                defaultDate: moment(new Date()).format("YYYY-MM-DD"),
                displayEventTime: false,
                editable: false,
                eventLimit: true,
                noEventsMessage: "Calender Entries Not Available",
                viewRender: (view, element) => {
                    var self  = this;
                    self.renderedView = view;
                },
                eventRender:(event, element) =>{

                },
                eventAfterAllRender: (view) => {
                    var quantity = $('.fc-event').length;
                },
                dayClick: function(date, jsEvent, view) {

                },
                eventClick: (event) => {
                    this.selectedEvent = event;
                    if (this.selectedEvent.id != undefined) {
                        if (this.selectedEvent.id != null && this.selectedEvent.id != "") {
                            this.leave_holiday_id = this.selectedEvent.id;
                            if (this.leave_holiday_id != 0) {
                                this.loadLeaveHoliday();
                            }
                        }
                    }
                },
                header: {
                    left: '',
                    center: 'title',
                    right: 'listDay,listWeek,month,listMonth',
                },
                buttonText: {
                    'month': 'Month',
                    'listMonth': 'List',
                    'listWeek': 'Week',
                    'listDay': 'Day'
                }
            },
        }
    },
    beforeMount: function() {
        contex = this;
    },
    watch:{
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_leave_holiday_calendar') {
                        self.cantAccessPage = true;
                    }

                    if(permissions[i].name == 'add_leave_holiday_calendar'){
                        self.canAddLeave = true;
                    }

                    if(permissions[i].name == 'delete_leave_holiday_calendar'){
                        self.canDeleteLeave = true;
                    }
                }
            }
        },
        renderedView: function(){
            var self = this;
            self.getLeaveHolidayList();
        },
    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        //logged in user location
        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // if (userObj.roles.length > 0) {
            //     self.role_name = userObj.roles[0].name.toLowerCase();
            // }
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                var locationName = self.ucString(userObj["locationName"]);
                if (userObj["locationCode"] != null && userObj["locationCode"] != "") {
                    locationName += " | ";
                    locationName += userObj["locationCode"];
                }
                self.filter_location_id = {
                    value: userObj["location_id"],
                    text: locationName
                };
            }
        }
        self.loadFieldData(['location','technician_users']);
        self.getLeaveHolidayList();
    },
    metaInfo() {
      var titleStr = "Leave/Holiday Calendar | " +process.env.COPYRIGHT_NAME;
      if (this.showLeaveCalendarList == 1) {
        if (this.leave_holiday_id > 0) {
            titleStr = "Update Leave/Holiday | " +process.env.COPYRIGHT_NAME
        }else{
            titleStr = "Create Leave/Holiday | " +process.env.COPYRIGHT_NAME
        }
      }
      return{
          title: titleStr
      }
    },
    methods: {
        addLeaveHoliday() {
            var self = this;
            self.clearFields();
            self.showLeaveCalendarList = 1;
        },
        clearFields(){
            var self = this;
            self.type_select = {text:"Leave",value:"leave"};
            self.subject_class = "control-label";
            self.type_select_error_msg = "";
            self.leave_type = "";
            self.leave_type_error_msg = "";
            self.from_date = "";
            self.from_date_error_msg = "";
            self.to_date = "";
            self.to_date_error_msg = "";
            self.subject = "";
            self.description = "";
            self.user_id = "";
            self.user_error_msg = "";
            self.location_id = "";
            self.location_error_msg = "";
            self.subject_error_msg = "";
            self.common_error_msg = "";
            self.leave_holiday_id = 0;
            self.is_weekly = 0;
            self.weekDays = null;
            self.days_error_msg = "";
            self.disable_type_select = false;
            self.apply_all = false;
            self.leaveTypesArr = [{text:"Annual Leave",value:"Annual Leave"},{text:"Leave WOP",value:"Leave WOP"},{text:"Other",value:"Other"},
                {text:"Personal Leave",value:"Personal Leave"},{text:"Weekly",value:"Weekly"}];
        },
        backToCalendar() {
            var self = this;
            self.showLeaveCalendarList = 0;
            self.clearFields();
            self.getLeaveHolidayList();
        },
        createLeaveHoliday(flag) {
            var self = this;
            var error = false;
            self.type_select_error_msg = "";
            self.leave_type_error_msg = "";
            self.from_date_error_msg = "";
            self.to_date_error_msg = "";
            self.user_error_msg = "";
            self.location_error_msg = "";
            self.subject_error_msg = "";
            self.common_error_msg = "";
            self.days_error_msg = "";

            if (self.type_select != null) {
                if (self.type_select.value) {
                    //Type is Leave
                    if (self.type_select.value == "leave") {
                        if (!self.user_id || self.user_id == null || self.user_id == "") {
                            self.user_error_msg = "User Required.";
                            error = true;
                        }

                        if (!self.leave_type || self.leave_type == null || self.leave_type == "") {
                            self.leave_type_error_msg = "Leave Type Required.";
                            error = true;
                        }
                    }else{
                        if (!self.location_id || self.location_id == null || self.location_id == "") {
                            self.location_error_msg = "Location Required.";
                            error = true;
                        }
                        if (self.subject == null || self.subject.trim() == "") {
                            self.subject_error_msg = "Subject Required.";
                            error = true;
                        }
                    }
                    //for weekly leave
                    if (self.is_weekly == 1) {

                        if (self.weekDays == null || self.weekDays == "") {
                            self.days_error_msg = "Days Required.";
                            error = true;
                        }

                    }else{
                        if (!self.from_date || self.from_date == null || self.from_date == "") {
                            self.from_date_error_msg = "Start Date Required.";
                            error = true;
                        }
                        if (!self.to_date || self.to_date == null || self.to_date == "") {
                            self.to_date_error_msg = "End Date Required.";
                            error = true;
                        }
                        if ( self.from_date != null && self.to_date != null && self.from_date != "" && self.to_date != "" ) {
                            var fromDate = Date.parse(self.from_date);
                            var toDate = Date.parse(self.to_date);

                            if( toDate < fromDate ) {
                                self.to_date_error_msg = "End Date should be greater than Start Date.";
                                error = true;
                            }
                        }
                    }
                }
            }

            if (!error) {

                self.loading = true;

                if (flag == "Update") {
                    $("#updateLeaveCalendarBtn").val("Updating ...");
                    $("#updateLeaveCalendarBtn").prop("disabled", true);
                    $("#cancelLeaveCalendarBtn").prop("disabled",true);
                }else{
                    if (flag == "Save and Continue") {
                        $("#createAndContinueLeaveCalendarBtn").val("Saving ...");
                        $("#createLeaveCalendarBtn").prop("disabled",true);
                        $("#createAndContinueLeaveCalendarBtn").prop("disabled", true);
                        $("#cancelLeaveCalendarBtn").prop("disabled",true);
                    }else{
                        $("#createLeaveCalendarBtn").val("Saving ...");
                        $("#createLeaveCalendarBtn").prop("disabled", true);
                        $("#cancelLeaveCalendarBtn").prop("disabled",true);
                    }                    
                }

                var fields = $("#leaveHolidayForm").serializeArray();
                fields.push({name: "type", value: self.type_select.value});
                if (self.type_select.value == "leave") {
                    fields.push({name: "leave_type", value: self.leave_type.value});
                    fields.push({name: "user_id", value: self.user_id.value});
                }else{
                    fields.push({name: "location_id", value: self.location_id.value});
                }
                if (self.from_date != null && self.from_date != "") {
                    fields.push({name: "from_date", value:self.from_date});
                }else{
                    fields.push({name: "from_date", value:""});
                }
                if (self.to_date != null && self.to_date != "") {
                    fields.push({name: "to_date", value:self.to_date});
                }else{
                    fields.push({name: "to_date", value:""});
                }
                fields.push({name: "id", value: self.leave_holiday_id});
                if (self.is_weekly == 1) {
                    /*var daysArr = [];
                    /*if(self.weekDays != null && self.weekDays.length > 0){
                        for(var i = 0; i < self.weekDays.length; i++){
                            daysArr.push(self.weekDays[i].value);
                        }
                    }*/
                    fields.push({name: "days",value:self.weekDays.value});
                }else{
                    fields.push({name: "days",value:null});
                }
                if (self.apply_all == true) {
                    fields.push({name: "apply_all",value:1});
                }else{
                    fields.push({name: "apply_all",value:0});
                }

                $.ajax({
                    url: process.env.ROOT_API + "/leave/holiday/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (flag == "Update") {
                            $("#updateLeaveCalendarBtn").val("Update");
                            $("#updateLeaveCalendarBtn").prop("disabled", false);
                            $("#cancelLeaveCalendarBtn").prop("disabled",false);
                        }else{
                            if (flag == "Save and Continue") {
                                $("#createAndContinueLeaveCalendarBtn").val("Save and Continue");
                                $("#createLeaveCalendarBtn").prop("disabled",false);
                                $("#createAndContinueLeaveCalendarBtn").prop("disabled", false);
                                $("#cancelLeaveCalendarBtn").prop("disabled",false);
                            }else{
                                $("#createLeaveCalendarBtn").val("Save");
                                $("#createLeaveCalendarBtn").prop("disabled", false);
                                $("#cancelLeaveCalendarBtn").prop("disabled",false);
                            }
                        }

                        if (data.status == "success") {
                            if (flag == "Save and Continue") {
                                self.clearFields();     //clear all fields
                            }else{
                                self.showLeaveCalendarList =  0;
                                self.getLeaveHolidayList();
                                self.clearFields();     //clear all fields
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                // $("#errorMsg").html(err);
                                // $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    // $(".alert-warning").removeClass("show");
                                    // $(".alert-warning").addClass("hide");
                                    self.common_error_msg = "";
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (flag == "Update") {
                            $("#updateLeaveCalendarBtn").val("Update");
                            $("#updateLeaveCalendarBtn").prop("disabled", false);
                            $("#cancelLeaveCalendarBtn").prop("disabled",false);
                        }else{
                            if (flag == "Save and Continue") {
                                $("#createAndContinueLeaveCalendarBtn").val("Save and Continue");
                                $("#createLeaveCalendarBtn").prop("disabled",false);
                                $("#createAndContinueLeaveCalendarBtn").prop("disabled", false);
                                $("#cancelLeaveCalendarBtn").prop("disabled",false);
                            }else{
                                $("#createLeaveCalendarBtn").val("Save");
                                $("#createLeaveCalendarBtn").prop("disabled", false);
                                $("#cancelLeaveCalendarBtn").prop("disabled",false);
                            }
                        }
                        self.generateStatusCodeMessage(jqXHR, false, 'create-leave-holiday');
                    }
                });
            }
        },
        onTypeSelect() {
            var self = this;
            self.type_select_error_msg = "";
            self.leave_type_error_msg = "";
            self.from_date_error_msg = "";
            self.to_date_error_msg = "";
            self.user_error_msg = "";
            self.location_error_msg = "";
            self.subject_error_msg = "";
            self.user_id = "";
            self.location_id = "";
            self.leave_type = "";
            self.subject = "";
            self.from_date = "";
            self.to_date = "";
            self.description = "";
            self.is_weekly = 0;
            self.weekDays = null;
            self.days_error_msg = "";
            if (self.type_select != null) {
                if (self.type_select.value != null && self.type_select.value == "holiday") {
                    self.subject_class = "control-label require";
                }else{
                    self.subject_class = "control-label";
                }
            }else{
                self.subject_class = "control-label";
            }
        },
        previousMonth() {
            var self = this;
            self.$refs.LHcalendar.fireMethod('prev');
            self.start_date = self.$refs.LHcalendar.fireMethod('getView').start.format();
            self.end_date = self.$refs.LHcalendar.fireMethod('getView').end.format();
            self.getLeaveHolidayList();
        },
        nextMonth() {
            var self = this;
            self.$refs.LHcalendar.fireMethod('next');
            self.start_date = self.$refs.LHcalendar.fireMethod('getView').start.format();
            self.end_date = self.$refs.LHcalendar.fireMethod('getView').end.format();
            self.getLeaveHolidayList();
        },
        getLeaveHolidayList() {
            var self = this;
            self.loading = true;

            var startDateFrom = self.$refs.LHcalendar.fireMethod('getView').start.format();
            var endDateTo = self.$refs.LHcalendar.fireMethod('getView').end.format();

            self.start_date = (startDateFrom === null || typeof startDateFrom === "undefined") ? "" : startDateFrom;
            self.end_date = (endDateTo === null || typeof endDateTo === "undefined") ? "" : endDateTo;

            var locationId = "";
            if (self.filter_location_id != null && self.filter_location_id.value) {
                locationId = self.filter_location_id.value;
            }

            $.ajax({
                url: process.env.ROOT_API + "/leave/holiday/list",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data:{
                    start_date:self.start_date,
                    end_date:self.end_date,
                    location_id:locationId
                },
                success: function (data) {
                    self.loading = false;
                    self.events = [];
                    if (data.status == "success") {
                        self.keysArr = [];
                        self.display_events = data.content.row;
                        self.events = data.content.row;
                        $.each(data.content.keys, function (i) {
                            data.content.keys[i].is_view = 1;
                            self.keysArr.push(data.content.keys[i]);
                        });
                        self.$refs.LHcalendar.$emit('refetch-events');

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'leave-holiday-list');
                }
            });
        },
        loadLeaveHoliday() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/leave/holiday/"+self.leave_holiday_id,
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.showLeaveCalendarList = 1;
                        self.leave_holiday_id = data.content.id;
                        self.type_select = {text:data.content.type_select_text,value:data.content.type};
                        self.from_date = data.content.start_date;
                        self.to_date = data.content.end_date;
                        self.weekDays = null;
                        self.disable_type_select = false;
                        self.apply_all = false;
                        if (data.content.type == "leave") {
                            if (data.content.leave_type.toLowerCase() == 'weekly') {
                                self.is_weekly = 1;
                                self.disable_type_select = true;
                                self.leaveTypesArr = [{text:"Weekly",value:"Weekly"}];
                                if (data.content.days != null && data.content.days != "") {
                                    // var daysArr = JSON.parse(data.content.days);
                                    // for(var i = 0; i < daysArr.length; i++){
                                    //     self.weekDays.push({text:self.titleCase(daysArr[i]),value:daysArr[i]});
                                    // }
                                    self.weekDays = {text:self.titleCase(data.content.days),value:data.content.days};
                                }
                            }else{
                                self.is_weekly = 0;
                                self.leaveTypesArr = [{text:"Annual Leave",value:"Annual Leave"},{text:"Leave WOP",value:"Leave WOP"},{text:"Other",value:"Other"},
                                    {text:"Personal Leave",value:"Personal Leave"}];
                            }
                        }else{
                            self.is_weekly = 0;
                            self.leaveTypesArr = [{text:"Annual Leave",value:"Annual Leave"},{text:"Leave WOP",value:"Leave WOP"},{text:"Other",value:"Other"},
                                    {text:"Personal Leave",value:"Personal Leave"}];
                        }
                        self.subject = data.content.subject;
                        if (data.content.type == "leave") {
                            self.subject_class = "control-label";
                            self.description = data.content.description;
                            self.leave_type = {text:data.content.leave_type,value:data.content.leave_type};
                            if (data.content.user_id != null) {
                                var uName = "";
                                if (data.content.first_name != null && data.content.first_name != "") {
                                    uName = self.ucString(data.content.first_name);
                                }
                                if (data.content.last_name != null && data.content.last_name != "") {
                                    uName += " ";
                                    uName += self.ucString(data.content.last_name);
                                }
                                self.user_id = {text:uName,value:data.content.user_id};
                            }else{
                                self.user_id = null;
                            }
                        }else{
                            self.subject_class = "control-label require";
                            if (data.content.location_id != null) {
                                var locName = "";
                                if (data.content.loc_code != null && data.content.loc_code != "") {
                                    locName = data.content.loc_code;
                                }
                                if (data.content.company_name != null && data.content.company_name != "") {
                                    locName += " | ";
                                    locName += self.ucString(data.content.company_name);
                                }
                                self.location_id = {text:locName,value:data.content.location_id};
                            }else{
                                self.location_id = null;
                            }
                        }
                        self.showLeaveCalendarList = 1;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'leave-holiday-data');
                }
            });
        },
        deleteLeaveHoliday() {
            var self = this;
            if (self.leave_holiday_id != 0) {
                var message = "Are you sure that you want to remove this Leave?";
                if (self.type_select.value == "holiday") {
                    message = "Are you sure that you want to remove this Holiday?";
                }
                if (confirm(message)) {
                    var applyVal = 0;
                    if (self.apply_all == true) {
                        applyVal = 1;
                    }
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/leave/holiday/delete",
                        type: "POST",
                        headers: this.ajxHeaders,
                        crossDomain: true,
                        dataType: "json",
                        data:{
                            id:self.leave_holiday_id,
                            all:applyVal
                        },
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                self.showLeaveCalendarList =  0;
                                self.getLeaveHolidayList();
                                self.clearFields();     //clear all fields
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, false, 'leave-holiday-delete');
                        }
                    });
                }
            }
        },
        changeVisible(id) {
            var self = this;
            var activeKey = [];
            var tempArr = self.keysArr;
            self.keysArr = [];
            $.each(tempArr, function (i) {
                if (id == tempArr[i].value) {
                    tempArr[i].is_view = (tempArr[i].is_view == 1) ? 0 : 1;
                }
                if (tempArr[i].is_view == 1) {
                    activeKey.push(tempArr[i].value);
                }
                self.keysArr.push(tempArr[i]);
            });
            self.$nextTick(function () {
                self.display_events = [];
                $.each(self.events, function (i) {
                    if ($.inArray(self.events[i].status_id, activeKey) != "-1") {
                        self.display_events.push(self.events[i]);
                    }
                });
                self.$refs.LHcalendar.$emit('refetch-events');
            });
        },
        onLocationChange() {
            var self = this;
            self.getLeaveHolidayList();
        },
        resetFilter() {
            var self = this;
            self.filter_location_id = "";
            self.getLeaveHolidayList();
        },
        onLeaveTypeChange() {
            var self = this;
            if (self.leave_type != null) {
                if (self.leave_type.value && self.leave_type.value.toLowerCase() == 'weekly') {
                    self.is_weekly = 1;
                    self.from_date = '';
                    self.to_date = '';
                    self.weekDays = null;
                    self.days_error_msg = "";
                }else{
                    self.is_weekly = 0;
                    self.from_date = '';
                    self.to_date = '';
                    self.weekDays = null;
                    self.days_error_msg = "";
                }
            }else{
                self.is_weekly = 0;
                self.from_date = '';
                self.to_date = '';
                self.weekDays = null;
                self.days_error_msg = "";
            }
        },
        applyAll(evt) {
            var self = this;
            if (evt.target.checked) {
                self.apply_all = true;
            }else{
                self.apply_all = false;
            }
        }
    }
};
//show calendar page on click sidebar menu
EventBus.$on('showLeaveHolidayPage', function (isLogin) {

    if ( contex.showLeaveCalendarList == 1 ) {
        contex.showLeaveCalendarList = 0;
    }

});
</script>


// WEBPACK FOOTER //
// src/components/LeaveHolidayCalendar.vue